import { useEffect, useState } from 'react'

// Divide una imagen vertical alta en N tiras horizontales usando
// background-position sobre divs. Evita canvas para no depender de
// CORS del WMS oficial.
//
// url    → URL de la imagen (GetLegendGraphic del WMS)
// splits → número de tiras (por defecto 3)
// height → altura de cada tira en px (por defecto 128)
// gap    → separación en px entre tiras (por defecto 12)
export default function SplitLegend({ url, splits = 3, height = 128, gap = 12 }) {
  const [dims, setDims] = useState(null)

  useEffect(() => {
    const img = new window.Image()
    img.onload = () => setDims({ w: img.naturalWidth, h: img.naturalHeight })
    img.src = url
  }, [url])

  if (!dims) {
    return (
      <div style={{ width: '100%', height, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#B0A89E', fontSize: 11 }}>
        Cargando leyenda…
      </div>
    )
  }
  const partH = dims.h / splits
  const scale = height / partH
  const stripW = dims.w * scale

  return (
    <div style={{ display: 'flex', gap, alignItems: 'center', justifyContent: 'center', height }}>
      {Array.from({ length: splits }).map((_, i) => (
        <div key={i} style={{
          width: stripW,
          height,
          border: '1px solid #EDE7DE',
          background: `#FFF url("${url}") no-repeat 0 ${-i * partH * scale}px / ${dims.w * scale}px ${dims.h * scale}px`,
        }} />
      ))}
    </div>
  )
}
